<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="New Donation Category" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-text-field
              outlined autofocus
              :hide-details="nameErrors.length === 0"
              dense
              :error-messages="nameErrors"
              v-model="DonationCategory.name"
              label="Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select :loading="loading" item-value="id" item-text="name" single-line v-model="DonationCategory.MerchantAccountId" outlined :hide-details="merchantAccountErrors.length === 0" dense :error-messages="merchantAccountErrors" :items="merchants" label="Select Merchant Account"></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text="text" @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import donationCategoryService from "../service.js";
import merchantService from "@/modules/Merchant/service.js";

const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");

export default {
  props: {
    createDialog: {
      default: false,
    },
  },
  name: "create-donationCategory",
  data() {
    return {
      loading: false,
      dialog: false,
      DonationCategory: {
        name: null,
        MerchantAccountId: null,
      },
      merchants: []
    };
  },
  mixins: [validationMixin],
  validations: {
    DonationCategory: {
      name: {
        required,
        minLength: minLength(4),
      },
      MerchantAccountId: {
        required,
      },
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.DonationCategory.name.$dirty) return errors;
      if (!this.$v.DonationCategory.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.DonationCategory.name.minLength)
        errors.push("Field must be at least 4 characters long");
      return errors;
    },
    merchantAccountErrors() {
      const errors = [];
      if (!this.$v.DonationCategory.MerchantAccountId.$dirty) return errors;
      if (!this.$v.DonationCategory.MerchantAccountId.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
      if (val) {
        this.getMerchanAccount()
      }
    },
  },
  methods: {
    getMerchanAccount(){
      this.loading = true;
      merchantService.getAll().then(response => {
        
        this.loading = false;
        this.merchants = response.data
      }).catch(error => {
        this.loading = false;
        console.log('error getting merchants', error)
      })
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.DonationCategory = {
        name: null,
        MerchantAccountId: null
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        if (this.imageUrl) {
          this.DonationCategory.image = {
            imageUrl: this.imageUrl,
            TypeId: 9,
          };
        }
        this.loading = true;
        return donationCategoryService
          .create(this.DonationCategory)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "DonationCategory is created",
                });
              this.empty();
              this.loading = false;
              this.$emit("submit");
            }
          })
          .catch((err) => {
            console.log("error", err);
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
